import { useAuth } from '@/context/AuthContext';
import { BatchImplantCard } from '@/components/BatchImplantCard';
import { API } from './adminConstants';

const AdminBatchImplant = () => {
  const { getToken } = useAuth();
  return (
    <BatchImplantCard
      batchUrl={`${API}/admin/implant-batch`}
      statusUrl={(id) => `${API}/admin/implant-batch/${id}`}
      headers={{ Authorization: `Bearer ${getToken()}` }}
    />
  );
};

export default AdminBatchImplant;
